import EntitySearchAssign from '@app/src/pages/TabularImport/shared/components/EntitySearchAssign'
import type { EntitySearchAssignProps } from '@app/src/pages/TabularImport/shared/components/EntitySearchAssignProps'
import type { ProviderSearchResult } from '@app/src/pages/TabularImport/shared/tabularImportHooks'
import { useSearchProviders } from '@app/src/pages/TabularImport/shared/tabularImportHooks'
import React from 'react'

const ProviderSearchAssign: React.FC<EntitySearchAssignProps> = props => (
  <EntitySearchAssign<ProviderSearchResult>
    {...props}
    useSearch={useSearchProviders}
    idPrefix="WF #"
    getOptionDetail={option => option.country?.name ?? undefined}
    placeholder="Search providers..."
    name="providerSearch"
  />
)

export default ProviderSearchAssign
